<template>
  <div class="card card-plain">
    <div role="tab" id="headingOne" class="card-header">
      <a
        data-toggle="collapse"
        data-parent="#accordion"
        :href="`#${itemId}`"
        @click.prevent="activate"
        :aria-expanded="active"
        :aria-controls="`content-${itemId}`"
      >
        <slot name="title">
          {{ title }}
        </slot>
        <slot name="icon">
          <i v-if="!noIcon" class="now-ui-icons arrows-1_minimal-down" />
        </slot>
      </a>
    </div>
    <collapse-transition :duration="animationDuration">
      <div
        v-show="active"
        :id="`content-${itemId}`"
        role="tabpanel"
        :aria-labelledby="title"
        class="collapsed"
      >
        <div class="card-body">
          <slot />
        </div>
      </div>
    </collapse-transition>
  </div>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';

export default {
  name: 'CollapseItem',
  components: {
    CollapseTransition
  },
  inject: {
    animationDuration: {
      default: 250
    },
    multipleActive: {
      default: false
    },
    addItem: {
      default: () => {/* nothing */}
    },
    removeItem: {
      default: () => {/* nothing */}
    },
    deactivateAll: {
      default: () => {/* nothing */}
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    id: String, // skipcq: JS-0682
    noIcon: Boolean
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    itemId() {
      return this.id || this.title;
    }
  },
  mounted() {
    this.addItem(this);
  },
  destroyed() {
    if(this.$el && this.$el.parentNode) { // skipcq: JS-W1044
      this.$el.parentNode.removeChild(this.$el);
    }
    this.removeItem(this);
  },
  methods: {
    activate() {
      if(!this.multipleActive) {
        this.deactivateAll();
      }
      this.active = !this.active;
    }
  },
};
</script>
